import { isEmpty, Share } from '../../utils';
import { showMessage } from '../../ui/components/Toast';
import { getGymTimezone } from '../../utils/gyms';
import moment from 'moment-timezone';
import { GymResolver } from '../../services';

export const shouldLoadPartnerProfile = (
    previousWorkoutSession,
    currentWorkoutSession,
    userProfile,
    partnerProfile) => {

    if (workoutSessionPairedIdIsSameAsUserUid(currentWorkoutSession, userProfile)
        || workoutSessionIsSameAsPartnerProfile(currentWorkoutSession, partnerProfile)) {
        return false;
    }

    return workoutSessionHasPartner(currentWorkoutSession)
        && (isEmpty(partnerProfile) || newPartnerIsDifferentFromOldPartner(previousWorkoutSession, currentWorkoutSession))
}

export const shouldClearPartnerProfile = (workoutSession, userProfile, partnerProfile) => {
    return workoutSessionPairedIdIsSameAsUserUid(workoutSession, userProfile) &&
        isEmpty(partnerProfile) === false;
}

export const workoutSessionHasPartner = (workoutSession) => {
    return !!workoutSession.pairedSessionReference;
}

export const workoutSessionPairedIdIsSameAsUserUid = (workoutSession, userProfile) => {
    return workoutSession.pairedSessionUserProfileId === userProfile.uid;
}

export const newPartnerIsDifferentFromOldPartner = (previousWorkoutSession, currentWorkoutSession) => {
    return previousWorkoutSession.pairedSessionUserProfileId !== currentWorkoutSession.pairedSessionUserProfileId;
}

export const workoutSessionIsSameAsPartnerProfile = (workoutSession, partnerProfile) => {
    return workoutSession.pairedSessionUserProfileId == partnerProfile.uid
}

export const haveInvitesChanged = (invites, newInvites) => {
    return JSON.stringify(invites) !== JSON.stringify(newInvites);
}

export const hasBookingChanged = (booking, newBooking) => {
    return JSON.stringify(booking) !== JSON.stringify(newBooking);
}

export const workoutTypeWithBodyGroups = (workoutSettings, t) => {
    return `What to expect`;
}

const bufferMinutesToAllowCheckin = 1;
export const minutesToAllowBookingsAfterClassStarted = 10 - bufferMinutesToAllowCheckin;

export const getWorkoutOrInvite = (booking, invites) => {
    if (invites.length > 0) {
        return invites[0];
    }
    return booking;
}

export const shareOpenInviteLink = async (t, link, userProfile, date) => {
    const personalisedHeader = GymResolver.getPersonalisedHeader(userProfile.gymName);
    const messageDetails = {
        link,
        fullname: userProfile.fullname.toUpperCase(),
        interpolation: { escapeValue: false },
        personalisedHeader,
    }
    if (date) {
        messageDetails.date = moment(date).format('DD MMM YYYY HH:mm')
    }
    const result = await Share.share({
        message: t('home:openInviteUser', messageDetails),
        title: t('home:inviteUserToJoinFitillion', { personalisedHeader }),
    });

    if (result.action === Share.sharedAction) {
        showMessage(t('home:inviteHasBeenSent'));
    }
}

export const isBookingInOneHour = (booking) => {
    if (!booking) {
        return false;
    }

    const gymTimezone = getGymTimezone(booking);
    return !moment(booking.startTime)
            .tz(gymTimezone)
            .diff(moment(new Date()).tz(gymTimezone), 'hour');
}

export const minuteIntervalForSpinner = 15;
export const allowedDaysToBookAhead = 14;
export const getMinuteForNextInterval = (date) => {
    const mo = moment(date);
    const nextClosestMinuteToMinuteInterval = Math.ceil((mo.minute() + 1) / minuteIntervalForSpinner) * minuteIntervalForSpinner;
    return mo.minute(nextClosestMinuteToMinuteInterval)
    .second(0)
    .valueOf();
}

export const isBookingForGroupWorkout = (booking) => {
    return !!(booking.openInviteLink || booking.pairedSessionReference)
}
